import { render } from "./AccordionTest.vue?vue&type=template&id=9357641a&scoped=true"
import script from "./AccordionTest.vue?vue&type=script&lang=js"
export * from "./AccordionTest.vue?vue&type=script&lang=js"

import "./AccordionTest.vue?vue&type=style&index=0&id=9357641a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9357641a"],['__file',"src/components/accordion/AccordionTest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9357641a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9357641a', __exports__)) {
    api.reload('9357641a', __exports__)
  }
  
  module.hot.accept("./AccordionTest.vue?vue&type=template&id=9357641a&scoped=true", () => {
    api.rerender('9357641a', render)
  })

}


export default __exports__